import { render } from "./ViewOnlyTaskPage.vue?vue&type=template&id=8f8c9824"
import script from "./ViewOnlyTaskPage.vue?vue&type=script&lang=js"
export * from "./ViewOnlyTaskPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__